import { Form, Select } from "antd";

import { ContainerForm } from "../styles";
import { useEffect } from "react";
import { useEmpreendimento } from "../hooks/useEmpreendimento";
import { Informacao } from "../Interface/Informacao";
import { validarCampos } from "../utils/validadores";

interface FormInfoProps {
  setFormInfo: (values: Partial<Informacao>) => void;
  formInfo: Partial<Informacao>;
  onValidChange: (isValid: boolean) => void;
}
/**
 * Formulário para verificação se Usuário está procurando ou disponibilizando.
 * Inclui campo de .
 * @returns Componente de formulário Procura Disponibiliza
 */

export default function FormInformacao({
  setFormInfo,
  formInfo,
  onValidChange,
}: FormInfoProps) {
  const [form] = Form.useForm();

  const formChange = async (_: Partial<any>, allValues: any) => {
    const valores = form.getFieldsValue(["idEmpreendimento"]);
    const isValid = validarCampos<Informacao>(valores, ["idEmpreendimento"]);

    onValidChange(isValid);
    if (isValid) {
      setFormInfo(allValues);
    }
  };

  useEffect(() => {
    if (formInfo) {
      form.setFieldsValue(formInfo);
    }
  }, [formInfo, form]);

  const { empreendimento, isLoading } = useEmpreendimento();
  return (
    <ContainerForm>
      <Form
        form={form}
        name="form-info"
        layout="vertical"
        autoComplete="off"
        style={{ maxWidth: 600 }}
        onValuesChange={(changedValues, allValues) =>
          formChange(changedValues, allValues)
        }
      >
        <Form.Item
          hasFeedback
          name={["idEmpreendimento"]}
          label="Empreendimento "
          className="formItems"
        >
          <Select placeholder="Empreendimento">
            {empreendimento.map((emp, index) => (
              <Select.Option key={emp.id} value={emp.id}>
                {emp.nome}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </ContainerForm>
  );
}
